var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { Billing } from './Enums';
const Default = {
    id: 0,
    companyId: 2,
    checkpoints: [
        'NameAndNationalId',
        'MaritalStatus',
        'NameChange',
        'DriversLicense',
        'Children'
    ],
    customName: 'MyService',
    billingType: Billing.PerUnit,
    price: 30000,
    daysToDeliver: Math.ceil(Math.random() * 10),
    available: true,
    description: '',
    type: 'Basic'
};
export class ReportPackage {
    constructor(reportPackage = Default) {
        this.fromJson(reportPackage);
    }
    fromJson(reportPackage) {
        Object.assign(this, reportPackage);
    }
    toJson() {
        return {
            id: this.id,
            companyId: this.companyId,
            checkpoints: this.checkpoints,
            customName: this.customName,
            billingType: this.billingType,
            price: this.price,
            daysToDeliver: this.daysToDeliver,
            available: this.available,
            optionalCheckpoints: this.optionalCheckpoints,
            description: this.description,
            type: this.type
        };
    }
}
__decorate([
    observable
], ReportPackage.prototype, "id", void 0);
__decorate([
    observable
], ReportPackage.prototype, "companyId", void 0);
__decorate([
    observable
], ReportPackage.prototype, "checkpoints", void 0);
__decorate([
    observable
], ReportPackage.prototype, "customName", void 0);
__decorate([
    observable
], ReportPackage.prototype, "billingType", void 0);
__decorate([
    observable
], ReportPackage.prototype, "price", void 0);
__decorate([
    observable
], ReportPackage.prototype, "daysToDeliver", void 0);
__decorate([
    observable
], ReportPackage.prototype, "available", void 0);
__decorate([
    observable
], ReportPackage.prototype, "description", void 0);
__decorate([
    observable
], ReportPackage.prototype, "type", void 0);
__decorate([
    observable
], ReportPackage.prototype, "optionalCheckpoints", void 0);
__decorate([
    action
], ReportPackage.prototype, "fromJson", null);
__decorate([
    action
], ReportPackage.prototype, "toJson", null);
